import { Box } from '@material-ui/core';

import { useCheckoutSessionContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/contexts/CheckoutSessionContext';
import { useWidth } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useWidth';
import { CheckoutSessionDetailActionsDialog } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/components/CheckoutSessionDetailActionsDialog';
import { CheckoutSessionDetailAction } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/types/CheckoutSessionDetailAction';
import { BnplPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/_shared/entities/PaymentMethodDetail/BnplPaymentMethodDetailEntity';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { useTranslation } from '@/components/shared/hooks/useTranslation';

interface NextActionPayFirstInstalmentProps {
  paymentMethodDetailEntity: BnplPaymentMethodDetailEntity;
}

export const NextActionPayFirstInstalment = ({ paymentMethodDetailEntity }: NextActionPayFirstInstalmentProps) => {
  const { getTextIdTranslation } = useTranslation();
  const { checkoutSessionEntity } = useCheckoutSessionContext();

  const { opened, setOpened, toggleDialog } = useDialog();
  const { width, ref } = useWidth<HTMLDivElement>();

  const { selectedProvider } = paymentMethodDetailEntity;

  if (!selectedProvider || !checkoutSessionEntity) {
    return null;
  }

  return (
    <>
      <CustomPaper fill="grey.light">
        <div ref={ref}>
          <Box display="flex" flexDirection={width && width > 600 ? 'row' : 'column'} width="100%" gridGap={24}>
            <FlexColumn gridGap={4} flexGrow={1} minWidth={300}>
              <Font variant="body2" color="title" display="block">
                <Text strong tId={'PAY_FIRST_INSTALMENT_TITLE'} />
              </Font>
              <Font variant="body2" color="title" display="block">
                <Text
                  tId={
                    checkoutSessionEntity.isShareable()
                      ? 'PAY_FIRST_INSTALMENT_DESCRIPTION'
                      : 'PAY_FIRST_INSTALMENT_DESCRIPTION_NOT_SHAREABLE'
                  }
                  dynamicDataTexts={[getTextIdTranslation(selectedProvider)]}
                />
              </Font>
            </FlexColumn>
            {checkoutSessionEntity.isShareable() && (
              <Box flexShrink={0} display="flex" alignItems="center">
                <StandardButton main size="small" onClick={toggleDialog}>
                  <Text tId={'SHARE_WITH_CUSTOMER'} />
                </StandardButton>
              </Box>
            )}
          </Box>
        </div>
      </CustomPaper>
      <CheckoutSessionDetailActionsDialog
        currentAction={CheckoutSessionDetailAction.SHARE}
        checkoutSession={checkoutSessionEntity.checkoutSession}
        useDialogProps={{ opened, setOpened, toggleDialog }}
        hppId={checkoutSessionEntity.hppId}
      />
    </>
  );
};
